// Generated by CoffeeScript 1.12.7
(function() {
  var CommonJs, isClass, isFunction, ref;

  ref = require('./TypesExtended'), isClass = ref.isClass, isFunction = ref.isFunction;

  module.exports = CommonJs = (function() {
    var definingModule;

    function CommonJs() {}

    definingModule = null;

    CommonJs.getModuleBeingDefined = function() {
      return definingModule;
    };


    /*
    IN:
      defineFunciton ||
     */

    CommonJs.defineModule = function(_module, a) {
      var lastModule, mod, result;
      lastModule = definingModule;
      definingModule = _module;
      mod = isFunction(a) ? isClass(a) ? a : a() : a;
      result = _module.exports = (mod != null ? typeof mod.createWithPostCreate === "function" ? mod.createWithPostCreate(mod) : void 0 : void 0) || mod;
      definingModule = lastModule;
      return result;
    };

    return CommonJs;

  })();

}).call(this);

//# sourceMappingURL=CommonJs.js.map
